<template>
  <div class="notfound">
    <h1>
      Page not found
    </h1>
    <primary-button
      v-if="!domainLimitedAccess"
      href="/"
    >
      Go to homepage
    </primary-button>
  </div>
</template>
<script>
import { mapState } from "vuex"

export default {
  computed: {
    ...mapState(["domainLimitedAccess"])
  }
}
</script>
